import React from 'react';
import { formatPrice } from '../../../utils';
import { PAYMENT_TYPE_LABELS, PAYMENT_TYPES } from '../../../constants';
import OrderDetailsPaymentForm from './OrderDetailsPaymentForm';

const OrderDetailsSummary = ({
  totalAmount,
  discountedTotalAmount,
  iskontoluToplam,
  vadeliToplam,
  toplamOdeme,
  remainingAmount,
  paidAmount,
  isPaymentCompleted,
  genelIskontoYuzde,
  vadeliYuzde,
  handleGenelIskontoYuzdeChange,
  handleVadeliYuzdeChange,
  handlePaymentCompletedChange,
  isMontajci,
  isLoading,
  isSavingPayment,
  isEditMode,
  paymentHistory,
  setCancelPaymentConfirm,
  handleSavePricingFields,
  isSavingVadeli,
  // Payment Form Props
  customerId,
  orders,
  newPaymentType,
  setNewPaymentType,
  newPaymentAmount,
  setNewPaymentAmount,
  isAddingPayment,
  handleAddPayment
}) => {
  const iskYuzde = parseFloat(genelIskontoYuzde) || 0;
  const vadYuzde = parseFloat(vadeliYuzde) || 0;

  return (
    <div className="total-section">
      <div className="totals-grid">
        {/* ARA TOPLAM */}
        <div className="total-item">
          <span className="total-label">Ara Toplam</span>
          <span className="total-value">{formatPrice(totalAmount)} ₺</span>
        </div>

        {/* ÜRÜN İNDİRİMLİ TOPLAM (Opsiyonel) */}
        {discountedTotalAmount !== totalAmount && (
          <div className="total-item discounted">
            <span className="total-label">Ürün İndirimli Toplam</span>
            <span className="total-value">{formatPrice(discountedTotalAmount)} ₺</span>
          </div>
        )}

        {/* GENEL İSKONTO GİRİŞİ */}
        {!isMontajci && (
          <div className="total-item iskontolu-input">
            <span className="total-label">Genel İskonto (%)</span>
            <input
              type="number"
              step="0.1"
              min="0"
              max="100"
              value={genelIskontoYuzde || ''}
              onChange={(e) => handleGenelIskontoYuzdeChange(e.target.value)}
              placeholder="%"
              className="vadeli-input-field"
            />
          </div>
        )}

        {/* İSKONTOLU TOPLAM (Sadece iskonto varsa) */}
        {iskYuzde > 0 && (
          <div className="total-item iskontolu">
            <span className="total-label">İskontolu Toplam</span>
            <span className="total-value">{formatPrice(iskontoluToplam)} ₺</span>
          </div>
        )}

        {/* VADE FARKI GİRİŞİ */}
        {!isMontajci && (
          <div className="total-item vadeli-input">
            <span className="total-label">Vade Farkı (%)</span>
            <input
              type="number"
              step="0.1"
              min="0"
              max="100"
              value={vadeliYuzde || ''}
              onChange={(e) => handleVadeliYuzdeChange(e.target.value)}
              placeholder="%"
              className="vadeli-input-field"
            />
          </div>
        )}

        {/* VADELİ TOPLAM (Sadece vade varsa) */}
        {vadYuzde > 0 && (
          <div className="total-item vadeli">
            <span className="total-label">Vadeli Toplam</span>
            <span className="total-value">{formatPrice(vadeliToplam)} ₺</span>
          </div>
        )}

        {/* GENEL TOPLAM (NET) */}
        <div className="total-item toplam-odeme">
          <span className="total-label">Genel Toplam (Net)</span>
          <span className="total-value">{formatPrice(toplamOdeme)} ₺</span>
        </div>

        {/* ÖDEME DURUMU */}
        {!isMontajci && (
          <div className="total-item payment-section">
            <div className="payment-checkbox-wrapper">
              <label className="payment-checkbox-label">
                <input
                  type="checkbox"
                  checked={isPaymentCompleted}
                  onChange={(e) => handlePaymentCompletedChange(e.target.checked)}
                  disabled={isLoading || isSavingPayment}
                  className="payment-checkbox"
                />
                <span>Ödeme Tamamlandı</span>
              </label>
            </div>
          </div>
        )}

        {/* TOPLAM ÖDENEN */}
        {!isMontajci && (
          <div className="total-item paid-amount">
            <span className="total-label">Toplam Ödenen</span>
            <span className="total-value">{formatPrice(parseFloat(paidAmount) || 0)} ₺</span>
          </div>
        )}

        {/* KALAN ÖDEME */}
        {!isMontajci && (
          <div className="total-item remaining-amount">
            <span className="total-label">Kalan Ödeme</span>
            <span className={`total-value ${remainingAmount === 0 ? 'payment-completed' : ''}`}>
              {remainingAmount === 0 ? (
                <>
                  <i className="fas fa-check-circle"></i>
                  {isPaymentCompleted ? 'Ödeme Alındı' : '0.00'}
                </>
              ) : (
                <>{formatPrice(remainingAmount)} ₺</>
              )}
            </span>
          </div>
        )}
      </div>

      {/* YENİ ÖDEME EKLE FORMU (Ödeme Geçmişinin Üstünde) */}
      {!isMontajci && (
        <OrderDetailsPaymentForm
          isEditMode={isEditMode}
          customerId={customerId}
          orders={orders}
          isMontajci={isMontajci}
          isPaymentCompleted={isPaymentCompleted}
          newPaymentType={newPaymentType}
          setNewPaymentType={setNewPaymentType}
          newPaymentAmount={newPaymentAmount}
          setNewPaymentAmount={setNewPaymentAmount}
          isAddingPayment={isAddingPayment}
          handleAddPayment={handleAddPayment}
          isLoading={isLoading}
        />
      )}

      {/* ÖDEME GEÇMİŞİ */}
      {!isMontajci && paymentHistory.length > 0 && (
        <div className="payment-history-section">
          <h5><i className="fas fa-history"></i> Ödeme Geçmişi</h5>
          <div className="payment-history-list">
            {paymentHistory.map((payment, index) => (
              <div key={payment.id || index} className="payment-history-item">
                <div className="payment-history-info">
                  <span className={`payment-type-badge payment-type-${payment.type}`}>
                    {PAYMENT_TYPE_LABELS[payment.type] || payment.type}
                  </span>
                  <span className="payment-amount">{formatPrice(payment.amount)} ₺</span>
                </div>
                <div className="payment-history-right">
                  <div className="payment-history-date">
                    {new Date(payment.date).toLocaleDateString('tr-TR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                  <button
                    type="button"
                    className="payment-cancel-btn"
                    onClick={() => setCancelPaymentConfirm(payment)}
                    title="Ödemeyi İptal Et"
                  >
                    <i className="fas fa-trash-alt"></i>
                    İptal
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* KAYDET BUTONU */}
      {isEditMode && !isMontajci && (
        <div className="vadeli-save-section">
          <button
            type="button"
            onClick={handleSavePricingFields}
            className="vadeli-save-btn"
            disabled={isSavingVadeli || isLoading}
          >
            {isSavingVadeli ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                <span>Kaydediliyor...</span>
              </>
            ) : (
              <>
                <i className="fas fa-save"></i>
                <span>Fiyat Bilgilerini Kaydet</span>
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderDetailsSummary;
